var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-component'),_c('production-movements'),_c('cantidades-actuales'),_c('order-productions'),_c('recipes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }